module.exports = __webpack_public_path__ + "static/media/tierra-cafe.0e244536.jpg";